import { Avatar, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import { GenericAbortSignal } from "axios";
import { GroupMembersQueryResponse, GroupMembersQueryResponsePaginatedList, MemberType } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ListChildComponentProps } from "react-window";
import { GenericListDrawer, GenericListFilter, GenericListItemsType } from "views/common/GenericListDrawer";
import { UserProfileDialog } from "views/foundation/user/dialogs/UserProfileDialog";

////////////////////////////////////////////////////////////////////////////////

type ItemData = GenericListItemsType<GroupMembersQueryResponse>;

////////////////////////////////////////////////////////////////////////////////

interface IProps {
    groupId: string;
    groupName: string;
    onClose: () => void;
}

/**
 * Lista os Membros do Grupo.
 * @param props
 */
export const GroupMembersDrawer: React.FC<IProps> = (props) => {
    ////////////////////////////////////////////////////////////////////////////////
    const { groupId, groupName, onClose } = props;

    const api = useCoreApi();
    const { t } = useTranslation();

    const [viewUser, setViewUser] = useState<string | null>(null);

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const handleGetData = (genericFilter: GenericListFilter, signal: GenericAbortSignal | undefined): Promise<GroupMembersQueryResponsePaginatedList> => {
        return new Promise((resolve, reject) => {
            api.v1.group.getGroupMembers({
                ...genericFilter,
                groupId: groupId,
                expanded: true,

            }, { signal })
            .then((response) => resolve(response.data))
            .catch(reject);
        });
    };

    // Ao clicar em visualizar um usuário.
    const onItemClick = (item: GroupMembersQueryResponse) => {
        setViewUser(item.memberId);
    };

    /**
     * Renderiza uma linha da Lista.
     * @param props
     */
    function renderRow(props: ListChildComponentProps<ItemData>) {
        const { index, style } = props;
        const { items, onViewerClick } = props.data;

        const item = items[index];
        if (item == undefined) return <></>
        return (
            <div key={index} style={style}>
                <ListItem disableGutters
                    className={item.memberType == MemberType.User ? AppGlobalClassKeys.clickable : undefined}
                    onClick={item.memberType == MemberType.User ? () => onViewerClick && onViewerClick(item) : undefined}
                >
                    <ListItemAvatar sx={{ minWidth: 40 }}>
                        <Avatar
                            sx={(theme) => (
                                { width: 32, height: 32, backgroundColor: theme.palette.grey[200] }
                            )}
                            src={item.thumbnailUrl}
                        />
                    </ListItemAvatar>
                    <ListItemText
                        primary={item.name}
                        title={item.name}
                        primaryTypographyProps={{ noWrap: true, variant: "h6" }}
                    />
                </ListItem>
            </div>
        );
    }

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <GenericListDrawer
            title={t("Group.GroupMembersDrawer.Title")}
            subtitle={groupName}
            itemHeight={40}
            onClose={() => onClose()}
            onGetData={handleGetData}
            onViewerClick={onItemClick}
            emptyDataMessage={t("Group.GroupMembersDrawer.ListEmptyMessage")}
            emptyFilterMessage={t("Group.GroupMembersDrawer.NoRecordsFound")}
            renderRow={renderRow}
            footer={
                <UserProfileDialog
                    userId={viewUser}
                    onClose={() => setViewUser(null)}
                />
            }
        />
    );
};
